module.exports = __webpack_public_path__ + "img/ok.81d60f7c.svg";